<template>
  <transition name="myself-dialog-fade">
      <div class="click_btn_stream_mask">
          <div class="click_btn_stream_mask_inner ZHIHUISHU_QZMD" @click="needPlay()">
              <img class="click_btn_stream_mask_inner_img" src="https://image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202109/1faaad31098e45328117eeaccd0f6e74.png" alt="">
          </div>
      </div>
  </transition>
</template>

<script>
export default {
  name: 'playButton',
  methods: {
    needPlay () {
      this.$emit('operationForPlay')
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin showBoxFather() {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2;
  overflow: auto;
}
@mixin AnyElementCentered() {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.click_btn_stream_mask {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, .5);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index:1;
  .click_btn_stream_mask_inner {
    width: 100px;
    height: 100px;
    cursor: pointer;
    transition: transform 0.2s;
    border-radius: 50%;
    &:hover {
      transform: scale(1.05);
      box-shadow: 1px 1px 10px rgba(255, 255, 255, 0.5);
    }
    .click_btn_stream_mask_inner_img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}

.myself-dialog-fade-enter-active {
  animation: dialog-fadein 0.4s;
  .show_box_son {
    animation: dialog-zoom 0.4s;
  }
}

.myself-dialog-fade-leave-active {
  animation: dialog-fadeout 0.4s;
  .show_box_son {
    animation: dialog-out 0.4s;
  }
}

@keyframes dialog-fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes dialog-fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes dialog-zoom {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes dialog-out {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  100% {
    transform: translate(-50%, -50%) scale(0);
  }
}
</style>
